import { useEffect, useRef } from 'react';

/**
 * Prevents closing gestures (e.g. swipe close on Facebook in app browser).
 * https://stackoverflow.com/a/76950774
 */
export const PreventCloseGesture = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    const initialClientXRef = useRef<number>(0);

    useEffect(() => {
        if (containerRef.current === null) {
            return;
        }

        const current = containerRef.current;

        const touchStart = (e: TouchEvent) => {
            initialClientXRef.current = e.touches[0]!.clientX;
        };
        const preventTouch = (e: TouchEvent) => {
            const minValue = 5; // threshold

            const clientX = e.touches[0]!.clientX - initialClientXRef.current;

            // Vertical scrolling does not work when you start swiping horizontally.
            if (Math.abs(clientX) > minValue) {
                e.preventDefault();
                e.returnValue = false;

                return false;
            }
        };

        current.addEventListener('touchstart', touchStart);
        current.addEventListener('touchmove', preventTouch, {
            passive: false,
        });

        return () => {
            if (current) {
                current.removeEventListener('touchstart', touchStart);
                current.removeEventListener('touchmove', preventTouch, {
                    passive: false,
                } as EventListenerOptions);
            }
        };
    }, [containerRef]);

    return <div ref={containerRef}>{children}</div>;
};
